import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";

const empty = { name: "", email: "", phone: "", club_name: "", city: "", guests: "", preferred_date: "", message: "" };

const F = ({ id, label, children }) => <div><Label htmlFor={id} className="text-xs font-bold uppercase tracking-wider text-[#6B6157]">{label}</Label><div className="mt-1.5">{children}</div></div>;

export const ClubRequestForm = () => {
  const [form, setForm] = useState(empty);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/inquiries", { ...form, guests: Number(form.guests) || 0, option: "Club Night request", event_slug: "bourbon-club-nights" });
      setSent(true);
      setForm(empty);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  if (sent) {
    return (
      <div className="rounded-xl border border-[#E5DACA] bg-white p-8 text-center" data-testid="club-request-success">
        <p className="font-display text-2xl text-[#1F1B17]">Thanks, your request is in.</p>
        <p className="mt-2 text-[#6B6157]">We'll be in touch soon to talk dates.</p>
        <button type="button" onClick={() => setSent(false)} className="mt-5 text-xs font-bold uppercase tracking-widest text-[#A8832F]" data-testid="club-request-again-button">Send another request</button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="grid gap-4 rounded-xl border border-[#E5DACA] bg-white p-6 sm:grid-cols-2 sm:p-8" data-testid="club-request-form">
      <F id="cr-club" label="Club name"><Input id="cr-club" required value={form.club_name} onChange={set("club_name")} data-testid="club-name-input" /></F>
      <F id="cr-city" label="City, State"><Input id="cr-city" required value={form.city} onChange={set("city")} data-testid="club-city-input" /></F>
      <F id="cr-name" label="Your name"><Input id="cr-name" required value={form.name} onChange={set("name")} data-testid="club-contact-name-input" /></F>
      <F id="cr-email" label="Email"><Input id="cr-email" type="email" required value={form.email} onChange={set("email")} data-testid="club-email-input" /></F>
      <F id="cr-phone" label="Phone"><Input id="cr-phone" value={form.phone} onChange={set("phone")} data-testid="club-phone-input" /></F>
      <F id="cr-guests" label="Expected guests"><Input id="cr-guests" type="number" min="1" value={form.guests} onChange={set("guests")} data-testid="club-guests-input" /></F>
      <div className="sm:col-span-2"><F id="cr-date" label="Preferred date"><Input id="cr-date" type="date" value={form.preferred_date} onChange={set("preferred_date")} data-testid="club-date-input" /></F></div>
      <div className="sm:col-span-2"><F id="cr-msg" label="Tell us about your club and venue"><Textarea id="cr-msg" rows={4} value={form.message} onChange={set("message")} data-testid="club-message-input" /></F></div>
      <button type="submit" disabled={busy} data-testid="club-request-submit-button"
        className="rounded bg-[#141210] py-4 text-xs font-extrabold uppercase tracking-[0.2em] text-[#F3DDA4] transition-colors hover:bg-[#2A2520] disabled:opacity-50 sm:col-span-2">
        {busy ? "Sending…" : "Request a Club Night"}
      </button>
    </form>
  );
};
